import { MyDayOfWeek, WeekOfMonth } from '../enums';
import { WeekDay } from '@angular/common';

export function GetWeekDayMomentNumber(weekDay: MyDayOfWeek) {
  switch (weekDay) {
    case MyDayOfWeek.Monday:
      return WeekDay.Monday;
    case MyDayOfWeek.Tuesday:
      return WeekDay.Tuesday;
    case MyDayOfWeek.Wednesday:
      return WeekDay.Wednesday;
    case MyDayOfWeek.Thursday:
      return WeekDay.Thursday;
    case MyDayOfWeek.Friday:
      return WeekDay.Friday;
    case MyDayOfWeek.Saturday:
      return WeekDay.Saturday;
    case MyDayOfWeek.Sunday:
      return WeekDay.Sunday;
  }
}

export function GetWeekDayText(weekDay: MyDayOfWeek) {
  switch (weekDay) {
    case MyDayOfWeek.Monday:
      return 'Monday';
    case MyDayOfWeek.Tuesday:
      return 'Tuesday';
    case MyDayOfWeek.Wednesday:
      return 'Wednesday';
    case MyDayOfWeek.Thursday:
      return 'Thursday';
    case MyDayOfWeek.Friday:
      return 'Friday';
    case MyDayOfWeek.Saturday:
      return 'Saturday';
    case MyDayOfWeek.Sunday:
      return 'Sunday';
  }
}

  export function GetWeekOfMonthText(weekOfMonth: WeekOfMonth) {
    switch (weekOfMonth) {
      case WeekOfMonth.First:
        return '1st week';
      case WeekOfMonth.Second:
        return '2nd week';
      case WeekOfMonth.Third:
        return '3rd week';
      case WeekOfMonth.Fourth:
        return '4th week';
      case WeekOfMonth.Fifth:
        return '5th week';
    }
}
